import { FC, SVGProps } from "react";

const ChevronLeft: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="16"
      height="28"
      viewBox="0 0 16 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M15.0733 27.2584C15.5617 26.7701 15.5617 25.9784 15.0733 25.4901L3.58167 13.9984L15.07 2.51007C15.5583 2.02174 15.5583 1.23007 15.07 0.741738C14.5817 0.253405 13.79 0.253405 13.3017 0.741738L0.926666 13.1167C0.438334 13.6051 0.438334 14.3967 0.926666 14.8851L1.81 15.7684L1.81167 15.7667L13.3033 27.2584C13.7933 27.7467 14.585 27.7467 15.0733 27.2584Z"
        fill="white"
      />
    </svg>
  );
};

export default ChevronLeft;
